import React, { useEffect, useState } from "react";

// third-party imports
import {
  RiBookmarkLine,
  RiBookmarkFill,
} from "react-icons/ri";

// project imports
import { GoogleAnalyticsEnum, triggerFunction } from "../../utils/google-analytics";
import { useQuickInsightContext } from "../../context/quick_insights_context";
import Spinner from "../../components/spinner-component/SpinnerOne";
import { useUserContext } from "../../context/user_context";
import { countReactions, getOrCreateGuestId } from "../../utils";
import ToolTip from "../../common/Tooltip/ToolTip";

function BookmarkComponent({ selectedArticle, setIsOpen, openModalLogin }) {
  // Reading Variables from context
  const { isInteractionLoading, insightsUserInteraction, upsertInsightsUserInteraction } = useQuickInsightContext();
  const { loginData } = useUserContext();

  // State initialization
  const [bookmarksCount, setBookmarksCount] = useState(0);
  const [isBookmekedByMe, setIsBookmarkedByMe] = useState(false);

  // Get currentUser
  const member = (loginData && loginData.data) || null;
  const currentUserId = member ? member?.userRecordId || "" : getOrCreateGuestId();

  useEffect(() => {
    const allArticleInteractions = (insightsUserInteraction || [])?.filter(
      (i) => i?.insightId === selectedArticle?.id
    );

    // Total across all users
    const totalBookmarks = countReactions(allArticleInteractions, 'isBookmarked');

    // Current user's specific status
    const currentUserInteraction = allArticleInteractions.find(i => i.userId === currentUserId);
    const userHasBookmarked = currentUserInteraction ? currentUserInteraction.isBookmarked : false;

    setBookmarksCount(totalBookmarks);
    setIsBookmarkedByMe(userHasBookmarked);
  }, [insightsUserInteraction, selectedArticle?.id, currentUserId]);

  const handleNormalclose = () => {
    try {
      if (setIsOpen) {
        setIsOpen(false);
      }
    } catch (error) {
      console.log("52 : BookmarkComponent : Error handleNormalClose", error);
    }
  }

  // Handle function for Bookmark
  const handleBookmarked = async () => {
    try {
      if (!member) {
        handleNormalclose();
        openModalLogin();
        return;
      }

      const bookmarkedState = !isBookmekedByMe;

      // SetBookmarked and count
      setIsBookmarkedByMe(bookmarkedState);
      setBookmarksCount((prevCount) => (bookmarkedState ? prevCount + 1 : prevCount - 1));

      // payload for the upsert API
      const body = {
        userId: currentUserId || "",
        insightId: selectedArticle?.id || "",
        isBookmarked: bookmarkedState,
      };

      // Call upsert API function
      await upsertInsightsUserInteraction(body);

      // Optional: Trigger your Google Analytics only if it's a "Bookmark" action
      if (bookmarkedState) {
        triggerFunction(
          GoogleAnalyticsEnum.BUTTON,
          GoogleAnalyticsEnum.LSA_SALESFORCE_QUICK_INSIGHT_BOOKMARKED
        );
      }
    } catch (error) {
      console.error("77 : BookmarkComponent : Error in handleBookmarked", error);
    }
  };

  return (
    <div className="article-actions-wrapper">

      {isInteractionLoading && <Spinner />}

      <div className="article-actions">

        <div className="actions-spacer" />

        {/* Bookmarked */}
        <ToolTip title={"Bookmark"} id={"bookmark"} placement="bottom">
          <button
            type="button"
            className={`action-with-count ${isBookmekedByMe ? "saved" : ""
              }`}
            onClick={handleBookmarked}
            aria-label="Bookmarked"
          >
            {isBookmekedByMe ? (
              <RiBookmarkFill />
            ) : (
              <RiBookmarkLine />
            )}

            <span>{bookmarksCount}</span>
          </button>
        </ToolTip>

      </div>

    </div>
  );
}

export default BookmarkComponent;